import React, { useCallback, useEffect, useState } from "react";
import { useInput } from "react-admin";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import _, { debounce, filter } from "lodash";
import axios from "axios";
import { ONEMAP_SEARCH_ADDRESS_API_URL } from "../utils/const";
import { useField } from "react-final-form";
import { CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

export default function AddressAutoCompleteInput(props: any) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);

  const building = useField("building");
  const blockNumber = useField("blockNumber");
  const street = useField("street");
  const classes = useStyles();

  const {
    input: { onChange },
  } = useField(props.referenceSource);

  const { options, ...rest } = props;

  const {
    input,
    meta: { touched, error },
  } = useInput(rest);

  const callAddressApi = useCallback(
    debounce((searchVal: string) => {
      axios
        .request({
          method: "GET",
          url: `${ONEMAP_SEARCH_ADDRESS_API_URL}`,
          params: {
            searchVal,
            getAddrDetails: "Y",
            returnGeom: "Y",
            pageNum: 1,
          },
        })
        .then((res) => {
          if (res.data.found >= 1) {
            const addressFiltered = filter(res.data.results, function (o) {
              return o.POSTAL !== "NIL";
            });

            setAddressOptions(
              addressFiltered.map((item: any) => `${item.ADDRESS}`)
            );
            setLocationData(addressFiltered);
            setLoading(false);
          } else {
            setAddressOptions([]);
            setLocationData([]);
            setLoading(false);
          }
        })
        .catch((e) => {
          setAddressOptions([]);
          setLocationData([]);
          setLoading(false);
        });
    }, 1000),
    []
  );

  useEffect(() => {
    if (input.value !== "") {
      setLoading(true);
      callAddressApi(input.value);
    }
  }, [input.value]);

  return (
    <Autocomplete
      className={classes.root}
      options={addressOptions}
      onChange={(event, newValue) => {
        const selectedLocation = _.find(locationData, { ADDRESS: newValue });
        console.log("ONCHANGE", selectedLocation);
        onChange(selectedLocation);

        input.onChange(selectedLocation.POSTAL);
        building.input.onChange(
          selectedLocation.BUILDING === "NIL" ? "" : selectedLocation.BUILDING
        );
        blockNumber.input.onChange(
          selectedLocation.BLK_NO === "NIL" ? "" : selectedLocation.BLK_NO
        );
        street.input.onChange(
          selectedLocation.ROAD_NAME === "NIL" ? "" : selectedLocation.ROAD_NAME
        );
      }}
      freeSolo
      disableClearable
      value={input.value}
      inputValue={input.value}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          error={!!(touched && error)}
          helperText={touched && error}
          {...input}
          InputProps={{
            ...params.InputProps,
            type: "search",
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
